// ============================================================================
// FieldHint — one short line under a form field
// ============================================================================
// For a plain <input>/<textarea> whose meaning or effect is not obvious from
// its label ("Printed on tax documents. Does not change the rate."). Matches
// SyutSelect's `helperText`, which covers dropdowns. One line; anything longer
// belongs in the screen's help content, not the form.
// ============================================================================

import React from 'react';
import './guidance.css';

interface Props {
  children: React.ReactNode;
  id?: string;
}

export const FieldHint: React.FC<Props> = ({ children, id }) => (
  <span className="es-field-hint" id={id}>{children}</span>
);

export default FieldHint;
